import React from 'react';
import { Link } from 'react-router-dom';

const Categories = () => {
    const categoryData = [
        {
            name: "Web Design",
            img: "img/cat-1.jpg",
            link: "/courses?category=programming"
        },
        {
            name: "Graphic Design",
            img: "img/cat-2.jpg",
            link: "/courses?category=design"
        },
        {
            name: "Digital Marketing",
            img: "img/cat-3.jpg",
            link: "/courses?category=marketing"
        },
        {
            name: "Music & Audio",
            img: "img/cat-4.jpg",
            link: "/courses?category=music"
        }
    ];

    return (
        <section className="container-xxl py-5 category fundisha-marketing-section">
            <div className="container">
                <div className="fundisha-section-header text-center wow fadeInUp" data-wow-delay="0.1s">
                    <p className="fundisha-section-title">Categories</p>
                    <h1 className="mb-5">Popular Categories</h1>
                </div>
                <div className="row g-4">
                    {categoryData.map((cat, index) => (
                        <div key={index} className="col-12 col-sm-6 col-lg-3 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`}>
                            <Link className="category-item d-block text-center h-100" to={cat.link}>
                                <div className="overflow-hidden">
                                    <img className="img-fluid" src={cat.img} alt={cat.name} />
                                </div>
                                <div className="category-text p-4">
                                    <h5 className="mb-0">{cat.name}</h5>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Categories;